import { createSlice } from "@reduxjs/toolkit";
import { ReduxStateType } from "redux-store/types";

interface InitialState {
  status: ReduxStateType;
  data: any;
}

const initialState: InitialState = {
  status: ReduxStateType.INIT,
  data: null,
};

const getBirthdayDataSlice = createSlice({
  name: "getBirthdayData",
  initialState,
  reducers: {
    getBirthdayDataStart: (state, action) => {
      state.status = ReduxStateType.LOADING;
    },
    getBirthdayDataSuccess: (state, action) => {
      state.status = ReduxStateType.SUCCESS;
      state.data = action.payload;
    },
    getBirthdayDataFailed: (state) => {
      state.status = ReduxStateType.ERROR;
    },
  },
});

export const {
  getBirthdayDataStart,
  getBirthdayDataSuccess,
  getBirthdayDataFailed,
} = getBirthdayDataSlice.actions;

export default getBirthdayDataSlice.reducer;
